import { apiActionWrapper, ApiResult } from 'actions/api';
import { ApiError } from 'types/api-error';
import { get, post } from 'libs/request';
import { AnyAction, Action, Dispatch } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import env from 'libs/env';
import query from 'libs/query';
import bridge from 'libs/bridge';
import { API_EC, API_KEN } from 'config/host';
import Cookie from 'js-cookie';
import { AxiosRequestConfig } from 'axios';
import { IAppInfoExt } from 'src/types/bridge';

export const GET_PAY_CONFIG: ApiAction = {
    SUCCESS: 'GET_PAY_CONFIG_SUCCESS',
    FAILURE: 'GET_PAY_CONFIG_FAILURE',
    REQUEST: 'GET_PAY_CONFIG_REQUEST'
};

export const GET_ABTEST_INFO = {
    SUCCESS: 'GET_ABTEST_INFO_SUCCESS',
    REQUEST: 'GET_ABTEST_INFO_REQUEST',
    FAILURE: 'GET_ABTEST_INFO_FAILURE'
};

export const STOP_CHECK_QUEUE = 'STOP_CHECK_QUEUE';
export const START_CHECK_QUEUE = 'START_CHECK_QUEUE';
export const START_REQUEST_TOKEN = 'START_REQUEST_TOKEN';
export const CHECK_QUEUE = 'CHECK_QUEUE';
export const SET_PAY_METHOD = 'SET_PAY_METHOD';
export const PAY_STATUS = 'PAY_STATUS';
const SET_PAY_PARAMS = 'SET_PAY_PARAMS';
const SET_FAILURE = 'SET_FAILURE';
export const SET_PAY_METHOD_LIST = 'SET_PAY_METHOD_LIST';
export const CREATE_ORDER = 'CREATE_ORDER';
export const PAY_ORDER = 'PAY_ORDER';
export const CHECK_PAY_RESULT = 'CHECK_PAY_RESULT';
export const SET_PAY_RESULT = 'SET_PAY_RESULT';
const DISABLE_COD = 'DISABLE_COD';
export const DIRECT_PAY = 'DIRECT_PAY';
const SET_CONFIG_PARAMS = 'SET_CONFIG_PARAMS';
const ENQUEUE_ACTION = 'ENQUEUE_ACTION';
const SET_PAY_AMOUNT = 'SET_PAY_AMOUNT';
export const PAY_TIMEOUT = 'PAY_TIMEOUT';
export const SET_PAY_FAIL_MODAL = 'SET_PAY_FAIL_MODAL';
export const SET_RECENT_TOASTED = 'SET_RECENT_TOASTED';
export const SET_QUEUE_STATUS = 'SET_QUEUE_STATUS';
export const SET_QUEUE_TIPS = 'SET_QUEUE_TIPS';
export interface AddressIdNamePair {
    id: string;
    name: string;
}

export interface CouponInfo {
    coupon_id: number;
    coupon_meta_id: string;
}

export interface OrderFormWithExtra {
    postForm?: OrderForm | MultiOrderForm;
    extraInfo?: ExtraOrderInfo;
}

export interface ExtraOrderInfo {
    isVirtual: boolean;
    isBatchOrder: boolean;
}

export enum PayStatus {
    Init = 'Init',
    GettingConfig = 'GettingConfig',
    Ready = 'Ready',
    PreCreatingOrder = 'PreCreatingOrder',
    CreatingOrder = 'CreatingOrder',
    OrderFail = 'OrderFail',
    GettingPayParams = 'GettingPayParams',
    Paying = 'Paying',
    Checking = 'Checking',
    Success = 'Success',
    Fail = 'Fail',
    Queue = 'Queue',
    WaitingToken = 'WaitingToken'
}

export enum PayType {
    Wechat = 1,
    Alipay = 2
}

interface OrderProductSubmission {
    /** 商品id */
    product_id: string;
    /** SKU id */
    combo_id: string;
    /** 购物车id, 删除购物车用 */
    cart_id?: string;
    /** 购买数量 */
    combo_num: number;
    /** 买家留言 */
    buyer_words?: string;
    /** 优惠券选择 */
    coupon_info: {
        shop?: CouponInfo;
        platform?: CouponInfo;
    };
    /** 活动id */
    campaign_id?: string;
    /** 满减id */
    shop_full_discount?: string;
    /** 页面area_type, 标记来源用 */
    /* 商品是否支持退货运费险 */
    freight_insurance: boolean;
    // 推荐人 id
    author_id?: string;
}

interface OrderAddressSubmission {
    /** 地址信息 */
    post_addr?: {
        province: AddressIdNamePair;
        city: AddressIdNamePair;
        town: AddressIdNamePair;
        detail: string;
        tag?: string;
    };
    /** 收货人 */
    post_receiver?: string;
    /** 手机 */
    post_tel: string;
    /** 地址id */
    address_id?: number | string;
}

interface OrderMetricsSubmission {
    /** 页面area_type, 标记来源用 */
    area_type: string;
    /** 埋点用参数 */
    source_id?: string;
    /** 埋点用参数 */
    origin_id?: string;
    /** 埋点用参数 */
    source_type?: string;
    /** 埋点用参数 */
    extra?: string;
    /** 埋点用参数 */
    report_event?: string;
    pay_type?: number;
}

/** 外部需提供的创建订单用信息 */
export type OrderForm = OrderProductSubmission & OrderAddressSubmission & OrderMetricsSubmission;

export interface MultiOrderForm extends OrderAddressSubmission, OrderMetricsSubmission {
    orders: OrderProductSubmission[];
}

export interface CreateOrderAction {
    type: typeof CREATE_ORDER;
    payload?: OrderFormWithExtra;
}

export interface InternalOrderForm extends OrderForm {
    cid?: string;
    new_source_id?: string;
    pay_type?: number;
    sub_way?: number;
    // 来源类型：1.直播间, 2.短视频, 3.文章
    s_type?: string;
    // 应用子渠道标识  0-未知；1-app；2-小程序；3-H5
    sub_b_type?: string;
    // 小程序用户 openId
    open_id?: string;
    // 主播 ID
    author_id?: string;
    // 直播间 ID
    room_id?: string;
    // 风控黄牛下单验证 token
    token: string;
}

export interface PayOrderAction {
    type: typeof PAY_ORDER;
    payload: {
        id: string;
        area_type: string;
        total_amount?: number;
        payParams?: any;
    };
}

export interface CreateOrderExtra {
    isVirtual: boolean;
}

const getSchema = () => {
    const ua = window.navigator.userAgent;
    if (env.isAndroid) return 'snssdk143://';
    if (ua.indexOf('(NewsSocial') >= 0) return 'snssdk201://';
    if (ua.indexOf('(Explore') >= 0) return 'snssdk251://';
    if (ua.indexOf('(News') >= 0) return 'snssdk141://';

    return 'sslocal://';
};

const { isAndroid, isInToutiaoProduct } = env;

export const getSourceInfo = () => ({
    b_type: env.bType,
    buyin_track: query.buyin_track,
    env_type: isAndroid ? (isInToutiaoProduct ? '2' : '4') : isInToutiaoProduct ? '1' : '3',
    activity_id: query.activity_id || '',
    ...(query.page_id && { page_id: query.page_id }),
    origin_type: query.origin_type || '0',
    origin_id: query.origin_id || '0',
    new_source_type: query.new_source_type || '0',
    new_source_id: query.new_source_id || '0',
    source_type: query.source_type || '0',
    source_id: query.source_id || '0',
    schema: getSchema(),
    extra: JSON.stringify({
        ...(query.alkey && { alkey: query.alkey }),
        buyin_track: query.buyin_track
    }),
    entrance_params: decodeURIComponent(query.entrance_info || '{}')
});

interface GetPayFormsParams {
    productId?: string | string[];
    orderId?: string;
    shopIds?: string[];
    isOnlineOrder?: boolean;
    defaultPayType?: string;
    originType?: '0';
}

export interface ApiAction {
    SUCCESS: string;
    FAILURE: string;
    REQUEST: string;
}

export const getPayConfig = ({
    productId,
    orderId,
    shopIds,
    isOnlineOrder,
    defaultPayType
}: GetPayFormsParams): ThunkAction<void, any, undefined, Action> => (dispatch, getState) => {
    dispatch(enqueueAction());
    const { queueCount } = getState().pay;
    let actionMap: ApiAction = {
        SUCCESS: `${GET_PAY_CONFIG.SUCCESS}_${queueCount}`,
        FAILURE: `${GET_PAY_CONFIG.FAILURE}_${queueCount}`,
        REQUEST: `${GET_PAY_CONFIG.REQUEST}_${queueCount}`
    };
    if (transferStatus(dispatch, getState().pay.payStatus, PayStatus.GettingConfig)) {
        return bridge
            .call('appInfo', {}, { timeout: 500 })
            .then(
                (info: any) => (info && info.aid ? (info.aid as string) : '0'),
                () => '0'
            )
            .then((aid) =>
                dispatch(
                    apiActionWrapper(
                        actionMap,
                        get(`${API_KEN}/pay/getPayForms`, {
                            params: {
                                aid,
                                ...(orderId && { order_id: orderId }),
                                product_ids: Array.isArray(productId)
                                    ? productId.join(',')
                                    : productId,
                                is_online_order: isOnlineOrder,
                                ua: encodeURIComponent(window.navigator.userAgent),
                                default_pay_type: defaultPayType,
                                shop_ids: shopIds && shopIds.join(','),
                                origin_type: query.origin_type || ''
                            }
                        })
                    )
                )
            );
    }
};

export const setPayMethod = (method: number) => {
    return {
        type: SET_PAY_METHOD,
        payload: {
            method
        }
    };
};

const VALID_STATUS_TRANSITION: { [key in PayStatus]: PayStatus[] } = {
    [PayStatus.Init]: [PayStatus.GettingConfig, PayStatus.Checking],
    [PayStatus.GettingConfig]: [PayStatus.Ready, PayStatus.Checking],
    [PayStatus.Ready]: [
        PayStatus.Init,
        PayStatus.PreCreatingOrder,
        PayStatus.CreatingOrder,
        PayStatus.GettingPayParams,
        PayStatus.Ready,
        PayStatus.Checking,
        PayStatus.GettingConfig
    ],
    [PayStatus.PreCreatingOrder]: [
        PayStatus.Ready,
        PayStatus.CreatingOrder,
        PayStatus.PreCreatingOrder
    ],
    [PayStatus.CreatingOrder]: [
        PayStatus.OrderFail,
        PayStatus.Success,
        PayStatus.Paying,
        PayStatus.Queue,
        PayStatus.WaitingToken
    ],
    [PayStatus.OrderFail]: [
        PayStatus.Ready,
        PayStatus.PreCreatingOrder,
        PayStatus.CreatingOrder,
        PayStatus.GettingPayParams
    ],
    [PayStatus.GettingPayParams]: [PayStatus.Paying, PayStatus.OrderFail, PayStatus.Queue],
    [PayStatus.Paying]: [PayStatus.Checking, PayStatus.Fail],
    [PayStatus.Checking]: [PayStatus.Success, PayStatus.Fail],
    [PayStatus.Success]: [PayStatus.Init],
    [PayStatus.Fail]: [
        PayStatus.Paying,
        PayStatus.GettingPayParams,
        PayStatus.GettingConfig,
        PayStatus.Checking
    ],
    [PayStatus.Queue]: [PayStatus.Ready, PayStatus.Paying, PayStatus.Fail],
    [PayStatus.WaitingToken]: [PayStatus.CreatingOrder, PayStatus.OrderFail]
};

export const transferStatus = (dispatch: Dispatch, current: PayStatus, target: PayStatus) => {
    const valid = VALID_STATUS_TRANSITION[current].includes(target);
    if (valid) return dispatch(setPayStatus(target));
    console.warn(`transfer status fail:${current}->${target}`);
    return valid;
};

export const enqueueAction = () => {
    return {
        type: ENQUEUE_ACTION
    };
};

export const setPayMethodList = (list: PayMethod[] | undefined) => {
    return {
        type: SET_PAY_METHOD_LIST,
        payload: list
    };
};

export const setPayStatus = (status: PayStatus) => {
    return {
        type: PAY_STATUS,
        payload: status
    };
};

export const setPayParams = (data: PayParams | undefined) => {
    return {
        type: SET_PAY_PARAMS,
        payload: data
    };
};

export const setFailure = (data: ApiError | null) => {
    return {
        type: SET_FAILURE,
        payload: {
            data
        }
    };
};

export const setPayAmount = (amount: number) => {
    return {
        type: SET_PAY_AMOUNT,
        payload: {
            amount
        }
    };
};

export const setPayResult = (data: PayResult) => {
    return {
        type: SET_PAY_RESULT,
        payload: {
            data
        }
    };
};

export const setConfigParams = (params: any) => {
    return {
        type: SET_CONFIG_PARAMS,
        payload: params
    };
};

export const createOnlineOrder = async (
    data: InternalOrderForm,
    extra: ExtraOrderInfo
): Promise<any> => {
    const postParams = await getClientParams();
    let postUrl = `${API_EC}/order/newcreate`; // 立购提单

    if (extra && extra.isBatchOrder) postUrl = `${API_EC}/order/batchCreate`; // 购物车提单
    if (extra && extra.isVirtual) postUrl = `${API_EC}/order/newcreate/vtl`; // 虚拟商品提单
    return post(postUrl, data, { params: { ...postParams, can_queue: 1 } });
};

export const createCodOrder = (data: InternalOrderForm) => {
    return post(`${API_EC}/order/create`, data);
};

/**
 * @param id 可能为orderId或者tradeNo
 * @param orderId 当存在这个值时后端回传order_id为这个值
 * @param payType 支付方式
 * @param count 轮询次数
 */
export const checkQueue = (id: string, orderId: string, payType: number, count: number) =>
    get(
        `${API_EC}/order/getpay?id=${id}&pay_type=${payType}&cycle_count=${count}&order_id=${orderId}`
    );

export const requestToken = () => get(`${API_EC}/tokenService/getToken?act_type=order`);

export const getPayParams = async (data: any) => {
    const postParams = await getClientParams();

    return post(`${API_EC}/order/createpay`, data, { params: postParams });
};

const getClientParams = async (): Promise<{ [key: string]: string }> => {
    return new Promise((resolve) => {
        bridge
            .call('appInfo', {}, { timeout: 500 })
            .then((res) => {
                const appInfo: IAppInfoExt = res as IAppInfoExt;
                const { netType, device_platform, device_type } = appInfo;
                resolve({
                    ...(netType && { ac: netType }),
                    ...(device_platform && { device_platform }),
                    ...(device_type && { device_type })
                });
            })
            .catch(() => resolve({}));
    });
};

export const createOrder = (amount?: number) => {
    return {
        type: CREATE_ORDER,
        payload: {
            amount
        }
    };
};

export const checkPayResult = (orderId: string) => {
    return {
        type: CHECK_PAY_RESULT,
        payload: { id: orderId }
    };
};

export const payOrder = (orderId: string, amount?: number) => {
    return {
        type: PAY_ORDER,
        payload: {
            id: orderId,
            total_amount: amount
        }
    };
};

export const setDisableCod = (disable: boolean) => ({
    type: DISABLE_COD,
    payload: disable
});

export const setQueueStatus = (status: QueueStatus) => ({
    type: SET_QUEUE_STATUS,
    payload: status
});

export const setQueueTips = (text: string) => ({
    type: SET_QUEUE_TIPS,
    payload: text
});

export interface PayMethod {
    name?: string;
    type?: string;
    showName: string;
    payType: number;
    support: boolean;
    select: boolean;
    subWay?: number;
    recommend: boolean;
    plainName: string;
    weight: number;
    unsupportReason?: string;
    recommendText?: string;
}

export interface ConfigParams {
    productId?: string;
    orderId?: string;
}

export interface PayParams {
    orderIds?: string[];
    outTradeNo?: string;
    post_amount: string;
    order_id: string;
    total_amount: string;
    data?: {
        sdk_info: {
            url: string;
        };
    };
}

export interface PayResult {
    out_product_id: string;
    product_platform: string;
    product_id: string;
    order_id: string;
    final_status: number;
    total_amount?: number;
    post_amount?: number;
}

export interface AbInfoType {
    hidePayRecommend?: boolean;
    loaded: boolean;
    orderListVersion?: boolean;
}

export enum QueueStatus {
    IDLE = 'IDLE',
    // 开始排队
    START = 'START',
    // 静默排队中
    QUEUING_SILENCE = 'QUEUING_SILENCE',
    // 排队中
    QUEUING = 'QUEUING',
    // 取消排队中
    CANCELING = 'CANCELING',
    // 取消完成
    CANCELED = 'CANCELED',
    // 排队超时
    TIMEOUT = 'TIMEOUT'
}
export interface PayState {
    payMethodsList?: PayMethod[];
    chosenPayMethod?: PayMethod;
    payStatus: PayStatus;
    failure?: ApiError | null;
    payParams?: PayParams;
    needOpen: boolean; // 在获取到支付方式列表后自动打开
    getPayFormFail?: boolean;
    payResult: PayResult;
    shouldDisableCod: boolean;
    codDisabled: boolean;
    isCodPrevisouslySelected: boolean;
    directPay: number;
    getConfigParams?: ConfigParams;
    queueCount: number;
    payAmount?: number;
    showPayFailModal: boolean;
    recentToasted: boolean; // 已经展示过提示了，失败提示禁用
    abInfo: AbInfoType;
    queueStatus: QueueStatus; // 排队状态
    queueTips: string; // 排队状态文案，服务端返回
    loading: boolean;
    needSplitOrder: boolean; // 是否需要拆单支付
}

export interface WithPayState {
    pay: PayState;
    coupon: { selected: { shop: {}; platform: {} } };
}

const initState: PayState = {
    payStatus: PayStatus.Init,
    needOpen: false,
    failure: null,
    payResult: {
        out_product_id: '',
        product_platform: '',
        final_status: 0,
        product_id: '',
        order_id: ''
    },
    shouldDisableCod: false,
    codDisabled: false,
    isCodPrevisouslySelected: false,
    directPay: 0,
    getConfigParams: {
        productId: ''
    },
    queueCount: 0,
    showPayFailModal: false,
    recentToasted: false,
    abInfo: {
        loaded: false
    },
    queueStatus: QueueStatus.IDLE,
    queueTips: '',
    loading: false,
    needSplitOrder: false
};
/* eslint-disable complexity */
export default (state = initState, action: AnyAction): PayState => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case SET_PAY_METHOD:
            return setPayMethodHandler(state, action);
        case PAY_STATUS:
            return Object.assign(state, { payStatus: action.payload });
        case SET_PAY_PARAMS:
            if (
                action.payload &&
                !action.payload.order_id &&
                Array.isArray(action.payload.orderIds)
            ) {
                return {
                    ...state,
                    payParams: {
                        ...action.payload,
                        order_id: action.payload.orderIds[0]
                    }
                };
            }
            return Object.assign(state, {
                payParams: action.payload
            });
        case SET_FAILURE:
            return {
                ...state,
                failure: action.payload.data
            };
        case SET_PAY_METHOD_LIST:
            return {
                ...state,
                payMethodsList: action.payload
            };
        case SET_PAY_RESULT:
            return {
                ...state,
                payResult: action.payload.data
            };
        case DIRECT_PAY:
            return {
                ...state,
                directPay: state.directPay + action.payload
            };
        case DISABLE_COD:
            return computePaymethodsState(state, action.payload);
        case SET_CONFIG_PARAMS:
            return {
                ...state,
                getConfigParams: {
                    ...state.getConfigParams,
                    ...action.payload
                }
            };
        case ENQUEUE_ACTION:
            return {
                ...state,
                queueCount: state.queueCount + 1
            };
        case SET_PAY_AMOUNT:
            return {
                ...state,
                payAmount: action.payload && action.payload.amount
            };
        case PAY_TIMEOUT:
            return {
                ...state,
                showPayFailModal: true,
                recentToasted: true
            };
        case SET_PAY_FAIL_MODAL:
            return {
                ...state,
                showPayFailModal: action.payload
            };
        case SET_RECENT_TOASTED:
            return {
                ...state,
                recentToasted: action.payload
            };
        case GET_ABTEST_INFO.SUCCESS:
            return {
                ...state,
                abInfo: {
                    loaded: true,
                    hidePayRecommend:
                        action.payload.temai_ui &&
                        action.payload.temai_ui.hide_pay_recommend === true // 可能为undefined
                }
            };
        case SET_QUEUE_STATUS:
            return {
                ...state,
                queueStatus: action.payload
            };
        case SET_QUEUE_TIPS:
            return {
                ...state,
                queueTips: action.payload
            };
    }
    // 复杂action判断
    const { type } = action;
    switch (true) {
        case type.includes(GET_PAY_CONFIG.REQUEST): {
            return {
                ...state,
                payMethodsList: [],
                chosenPayMethod: undefined,
                loading: true
            };
        }
        case type.includes(GET_PAY_CONFIG.SUCCESS): {
            if (state.queueCount.toString() !== type.split('_').pop())
                return {
                    ...state,
                    loading: false
                };
            const payMethodsList = (action.payload.payMethodsList as PayMethod[]) || [];
            return {
                ...computePaymethodsState(
                    {
                        ...state,
                        payMethodsList,
                        chosenPayMethod: (payMethodsList || []).find(
                            (paymethod) => paymethod.select
                        ),
                        shouldDisableCod: false,
                        payStatus: VALID_STATUS_TRANSITION[state.payStatus].includes(
                            PayStatus.Ready
                        )
                            ? PayStatus.Ready
                            : state.payStatus
                    },
                    state.shouldDisableCod
                ),
                needSplitOrder: action.payload.needSplitOrder,
                loading: false
            };
        }
        case type.includes(GET_PAY_CONFIG.FAILURE):
            if (state.queueCount !== type.split('_').pop()) return { ...state, loading: false };
            return {
                ...getPayConfigFailHandler(state),
                loading: false
            };
        default:
            return state;
    }
};

const setPayMethodHandler = (state: PayState, action: AnyAction) => {
    return {
        ...state,
        chosenPayMethod: (state.payMethodsList || []).find(
            (paymethod) => paymethod.payType === action.payload.method
        ),
        isCodPrevisouslySelected: false,
        payParams: undefined
    };
};

const getPayConfigFailHandler = (state: PayState) => {
    return {
        ...state,
        payStatus: VALID_STATUS_TRANSITION[state.payStatus].includes(PayStatus.Ready)
            ? PayStatus.Ready
            : state.payStatus
    };
};

const computePaymethodsState = (state: PayState, shouldDisableCod: boolean) => {
    const statePayMethodsList = state.payMethodsList || [];
    const codPayMethod = statePayMethodsList.find((m) => m.payType === 0);
    if (shouldDisableCod) {
        if (codPayMethod && codPayMethod.support) {
            const payMethodsList = statePayMethodsList.map((m) =>
                m === codPayMethod
                    ? {
                          ...m,
                          support: false
                      }
                    : m
            );
            const isCodPrevisouslySelected = state.chosenPayMethod === codPayMethod;
            const chosenPayMethod =
                isCodPrevisouslySelected || !state.chosenPayMethod
                    ? payMethodsList.find((m) => m.support && m.select) ||
                      payMethodsList.find((m) => m.support)
                    : state.chosenPayMethod;
            return {
                ...state,
                shouldDisableCod: shouldDisableCod,
                codDisabled: true,
                payMethodsList,
                isCodPrevisouslySelected,
                chosenPayMethod
            };
        }
    } else {
        if (codPayMethod && state.codDisabled) {
            const payMethodsList = statePayMethodsList.map((m) =>
                m === codPayMethod
                    ? {
                          ...m,
                          support: true
                      }
                    : m
            );
            const chosenPayMethod = state.isCodPrevisouslySelected
                ? payMethodsList.find((m) => m.payType === 0)
                : state.chosenPayMethod;
            return {
                ...state,
                shouldDisableCod: shouldDisableCod,
                codDisabled: false,
                payMethodsList,
                chosenPayMethod,
                isCodPrevisouslySelected: false
            };
        }
    }
    return {
        ...state,
        shouldDisableCod: shouldDisableCod,
        codDisabled: false,
        chosenPayMethod:
            state.chosenPayMethod ||
            statePayMethodsList.find((m) => m.select) ||
            statePayMethodsList.find((m) => m.support)
    };
};

export const getAbtestInfo: () => ThunkAction<void, any, undefined, Action> = () => (
    dispatch: ThunkDispatch<any, undefined, Action>
) => {
    dispatch(
        apiActionWrapper(
            GET_ABTEST_INFO,
            get(`${API_EC}/index/getNewAbUiParams?token=aweme&key=douyin`)
        )
    );
};

// export const getAbtestInfo: () => ThunkAction<void, any, undefined, Action> = () => (
//     dispatch: ThunkDispatch<any, undefined, Action>
// ) => {
//     dispatch(
//         apiActionWrapper(GET_ABTEST_INFO, get(`${API_EC}/index/getNewAbUiParams?token=aweme`))
//     );
// };
